<div class="holder-conditions">
  <div class="document-conditions">
    <div id="inner-conditions" class="inner-conditions">
      <jhc-selectable-text [text]="content"></jhc-selectable-text>
    </div>
  </div>
</div>
